// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "all-260420-4/static/css/" + chunkId + "." + "7170e6ed" + ".chunk.css";
};